import { DateTime } from 'luxon';

// Convert timestamp cells to selected timezone
export function rowsToTimezone({
  headers,
  rows,
  timezone,
}: {
  headers: string[];
  rows: string[][];
  timezone: string;
}) {
  const timestampIndex = headers.indexOf('timestamp');

  const convertedRows =
    timestampIndex === -1
      ? rows
      : rows.map((row) =>
          row.map((cell, index) => {
            if (index !== timestampIndex) return cell;
            const dateTime = DateTime.fromISO(cell).setZone(timezone);
            return dateTime.isValid ? dateTime.toISO() : cell;
          })
        );

  return { headers, rows: convertedRows };
}
